import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { PropertiesTable } from "@/components/onboarding/PropertiesTable";

export const AdminProperties = () => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/properties").then((r) => setRows(r.data)).catch((e) => toast.error(errorText(e))), []);
  useEffect(() => { load(); }, [load]);
  return (
    <section className="space-y-4">
      <p className="text-sm text-slate-400">Every property that signed up, directly or through an MSP. Direct sign-up page: <a href="/signup" className="text-emerald-400">/signup</a></p>
      <PropertiesTable rows={rows} basePath="/admin/properties" onChange={load} showMsp />
    </section>
  );
};
